import React from 'react';
const Row = ({
  location,
  accent_color,
  own = null
}) => {
  var _location$car_count;
  return /*#__PURE__*/React.createElement("div", {
    className: `list-row list-item ${location.ranking === (own === null || own === void 0 ? void 0 : own.ranking) && 'list-item-own'}`,
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, location.ranking, "."), " ", location.location)), /*#__PURE__*/React.createElement("p", null, (_location$car_count = location.car_count) !== null && _location$car_count !== void 0 ? _location$car_count : '-'));
};
export default Row;